import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const productCreate = createAsyncThunk(
  "productCreate",
  async ({ data, form }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      const response = await axiosHttp.post(`product/create`, data, config);

      form.resetFields();
      message.success("Product has been uploaded successfully!");
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const createProductSlice = createSlice({
  name: "createProduct",
  initialState: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },

  extraReducers: (builder) => {
    builder.addCase(productCreate.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });

    builder.addCase(productCreate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.data = action.payload;
    });

    builder.addCase(productCreate.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    });
  },
});

export default createProductSlice.reducer;
